import { render } from "./ent_procedures.vue?vue&type=template&id=2737c146&scoped=true"
import script from "./ent_procedures.vue?vue&type=script&lang=js"
export * from "./ent_procedures.vue?vue&type=script&lang=js"

import "./ent_procedures.vue?vue&type=style&index=0&id=2737c146&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2737c146"]])

export default __exports__